import PropTypes from "prop-types"
import React, { useState } from "react"
import siteLogo from "../images/trc-logo.png"

function Nav({ siteTitle }) {
  const [isExpanded, toggleExpansion] = useState(false)
  return (
    <nav>
      <div class="site-brand">
        <span style={{ width: 150 }}>
          <img src={siteLogo} />
        </span>
      </div>
      <div class="block lg:hidden">
        <button
          onClick={() => toggleExpansion(!isExpanded)}
          class="flex items-center text-black"
        >
          <svg
            class="fill-current h-5 w-5"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div
        className={`${
          isExpanded ? `inline-block` : `hidden`
        } inline-block uppercase nav-items`}
      >
        <a href="#responsive-header">faq</a>
        <a href="#responsive-header">contact</a>
        <a href="#" class="btn cta_btn-header ">
          <span>download app</span>
        </a>
        <a href="#" class="btn cta_btn-header">
          <span>get your card</span>
        </a>
      </div>
    </nav>
  )
}

Nav.propTypes = {
  siteTitle: PropTypes.string,
}

Nav.defaultProps = {
  siteTitle: ``,
}

export default Nav
